import React from "react";
import {BulkActionPopupActionTypes,} from "../../../../../../management-pages/actions/action-types.enum";
import {OrderModel} from "../../../../../shared/models/order/order-item.model";
import BarekamButton, {SimpleButtons} from "../../../../../components/button";
import {BarekamIcon, IconVariants} from "../../../../../components/icon/barekam-icon";

export const BulkActionActions = ({row, onAction}: InWarehouseActionsProps) => {
    return (
        <div style={{width: '100%', display: 'flex', justifyContent: 'end'}}>
            {/*<ThreeDot>*/}
            {/*    {InWarehouseOrderRowActions.map(key =>*/}
            {/*        <MenuItem onClick={() => onAction && onAction(row, key as InWarehouseActionTypes)}*/}
            {/*                  key={key}>*/}
            {/*            <Message messageKey={ActionKeys[key]} sectionId={MessageSections.ORDERS}/>*/}
            {/*        </MenuItem>)}*/}
            {/*</ThreeDot>*/}

            <BarekamButton type={SimpleButtons.LINK}
                           onClick={() => onAction && onAction(row, BulkActionPopupActionTypes.REMOVE)}>
                <BarekamIcon variant={IconVariants.close} size={{width: '0.8rem', height: '0.8rem'}}/>
            </BarekamButton>
        </div>
    )
}

interface InWarehouseActionsProps {
    row: OrderModel;
    onAction?: (row: OrderModel, action: BulkActionPopupActionTypes) => void,
}